// extracted by mini-css-extract-plugin
module.exports = {"root":"IconSuccess_root__1sUsd","fillColor":"IconSuccess_fillColor__d6qpz"};